module.exports = __webpack_public_path__ + "img/maps_paniers.af4e9608.svg";